import classnames from 'classnames';
import Colors from "../../Color/Colors";
import { Icon } from "../../Icon/Icon/Icon";
import { IconButton } from "../../Button/IconButton/IconButton";
import { Text } from "../../Text/Text/Text";
import styles from "./AddonToggle.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var iconColor = '#FF715B';
export var AddonToggle = function AddonToggle(_ref) {
  var _ref$headline = _ref.headline,
    headline = _ref$headline === void 0 ? '' : _ref$headline,
    _ref$isEnabled = _ref.isEnabled,
    isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled,
    _ref$onClick = _ref.onClick,
    onClickInit = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$accessibilityLab = _ref.accessibilityLabel,
    accessibilityLabel = _ref$accessibilityLab === void 0 ? '' : _ref$accessibilityLab;
  var onClick = function onClick(event) {
    event.preventDefault();
    event.stopPropagation();
    onClickInit();
  };
  var icon = isEnabled ? 'trashcan' : 'add';
  return /*#__PURE__*/_jsxs("div", {
    className: styles.wrapper,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.content,
      children: [/*#__PURE__*/_jsx(Icon, {
        noFill: true,
        height: "32px",
        type: 'medication-access',
        width: "32px",
        fill: iconColor,
        className: classnames([styles.icon, {
          [styles.iconDisabled]: !isEnabled
        }])
      }), headline && /*#__PURE__*/_jsx(Text, {
        typog: "subhead2",
        textElement: "span",
        className: classnames([styles.headline, {
          [styles.headlineDisabled]: !isEnabled
        }]),
        children: headline
      })]
    }), /*#__PURE__*/_jsx(IconButton, {
      "aria-label": accessibilityLabel,
      className: styles.buttonWrapper,
      fill: Colors.colorBlack,
      icon: icon,
      onClick: onClick,
      size: isEnabled ? '15px' : '10px'
    })]
  });
};